<template lang="html">
  <div class="">
    <h1>404 Sorry not found your search page</h1>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// 404.vue?5ffa40fa